import { useFocusTimer } from '@/contexts/FocusTimerContext';
import { useNow } from '@/hooks/ui/useNow';
import { useThoughtForToday } from '@/hooks/wellbeing/useThoughtForToday';
import { BreakSheet } from './BreakSheet';
import { toViewModel } from './focusViewModel';

/**
 * The break sheet wired to the timer. Mounted once by `FocusTimerProvider`,
 * so it opens over whichever page the student is on.
 */
export function BreakSheetContainer() {
  const { state, dispatch, breakSheetOpen, closeBreakSheet } = useFocusTimer();
  const onBreak = state.phase === 'break';
  const now = useNow(breakSheetOpen && onBreak);
  const view = toViewModel(state, now);
  // Fetched when the sheet opens, not on every page this is mounted under.
  const { data: thought } = useThoughtForToday(now, {
    enabled: breakSheetOpen,
  });

  if (!view.lastBlock) return null;

  return (
    <BreakSheet
      open={breakSheetOpen}
      onClose={closeBreakSheet}
      block={view.lastBlock}
      breakKind={state.breakKind ?? 'short'}
      timeLabel={onBreak ? view.timeLabel : null}
      thought={thought}
      onSaveRecap={text => dispatch({ type: 'saveRecap', text })}
      onDismissRecap={() => dispatch({ type: 'dismissRecap' })}
      onBackToFocus={() => {
        dispatch({ type: 'nextBlock' });
        closeBreakSheet();
      }}
      onDone={() => {
        dispatch({ type: 'endSession' });
        closeBreakSheet();
      }}
    />
  );
}
